module.exports = {
      id: "lulu-money-usage",
      viewBox: "0 0 398 134",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#lulu-money",
      toString: function () {
        return this.url;
      }
    }